import LocalizedLink from '@components/Localization/LocalizedLink'
import { Box, OldText, linkStyles, theme } from '@gassan-ui'
import { getUrlSlugInLocale } from '@lib/get-url-slug-in-locale'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'

type Props = {
  size?: string | null
}

const Anchor = styled.a`
  ${linkStyles};
  font-family: ${theme.fonts.body};
  font-size: 0.75rem;
  color: ${theme.colors.shades[500]};
`

const SizeInfo: FC<Props> = ({ size }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['other'])
  return (
    <Box>
      {size === 'dont-know' ? (
        <OldText variant="micro" color="shades.500" mb="0" maxWidth="14rem">
          {t('reachOutForSize', { ns: 'other' })}
        </OldText>
      ) : (
        <LocalizedLink href={`/${getUrlSlugInLocale('sizeInformation', language)}`}>
          <Anchor target="_blank">{t('sizeInformation', { ns: 'other' })}</Anchor>
        </LocalizedLink>
      )}
    </Box>
  )
}

export default SizeInfo
